import { onMounted, computed, defineComponent, inject, ref, useContext, useCssModule } from '@nuxtjs/composition-api';
import { getUserIdCookie, setUserIdCookie, hasSpeechUserId, DEFAULT_TOOLTIP } from './';
import { useA11y, useAudioChunks } from '~/composables';
export default defineComponent({
    name: 'SpeechButton',
    inheritAttrs: false,
    props: {
        theme: {
            default: 'light',
            type: String,
            validator: (value) => {
                return ['a11y', 'light', 'dark', 'transparent', 'blue'].includes(value);
            },
        },
        tooltip: {
            default: false,
            type: [Boolean, Object],
        },
        isTooltipBanner: {
            default: false,
            type: Boolean,
        },
    },
    setup(props) {
        const a11y = useA11y();
        const context = useContext();
        const viewport = context.$viewport;
        const ym = context.$yandexMetrika;
        const css = useCssModule();
        const article = inject('article');
        const audio = computed(() => useAudioChunks(article?.url_alias || ''));
        const componentKey = ref(0);
        const isActive = ref(audio.value.isPlaying);
        const isAudioInit = ref(true);
        const isLoading = ref(audio.value.audioSpeechTask.isRunning);
        const isShowBanner = ref(false);
        audio.value.on('update', (audio) => {
            isActive.value = !audio.paused;
            componentKey.value += 1;
        });
        audio.value.onStatus('updateStatus', (_, isWaitLoadChunk) => {
            isLoading.value = isWaitLoadChunk;
        });
        const currentText = 'Материалы читает — синтез речи от Сбера';
        const currentPosition = computed(() => (viewport.isLessThan('tablet') ? 'top' : 'right'));
        const currentTooltip = computed(() => {
            return {
                ...DEFAULT_TOOLTIP,
                size: a11y.isEnabled ? 'small-plus' : 'small',
                width: !isShowBanner.value ? 'auto' : '233px',
                whiteSpace: !isShowBanner.value ? 'nowrap' : 'normal',
                padding: !isShowBanner.value ? '8px 16px' : '12px 16px 16px',
                gap: '16px',
                isVisibleTooltip: !isShowBanner.value,
                ...(typeof props.tooltip === 'object' && props.tooltip),
            };
        });
        function createCookie() {
            setUserIdCookie();
            isShowBanner.value = false;
        }
        async function handleClick() {
            if (!getUserIdCookie()) {
                createCookie();
            }
            if (audio.value.audioInit) {
                audio.value.playPause();
            }
            const event = new CustomEvent('playPause', {
                detail: article,
            });
            window.dispatchEvent(event);
            isShowBanner.value = false;
            if (!hasSpeechUserId()) {
                ym.reachGoal('start');
            }
        }
        function handleLogo() {
            ym.reachGoal('click_logo');
        }
        onMounted(() => {
            isShowBanner.value = !getUserIdCookie();
        });
        return {
            a11y,
            css,
            currentText,
            currentTooltip,
            currentPosition,
            isActive,
            isAudioInit,
            isShowBanner,
            isLoading,
            handleClick,
            handleLogo,
            createCookie,
        };
    },
});
